export enum BranchConfigStatus {
  Waiting = 0,
  CameraMapping = 1,
  CameraMapped = 2,
  AnalysisDraft = 3,
  AnalysisDrafted = 4,
}

export interface Branch {
  uid: string;
  name: string;
  client: { uid: string; name: string };
  configStatus: BranchConfigStatus;
  cameraCount: number;
  lineCount: number;
  zoneCount: number;
  // 버전이 1개 이상 있는지 (BE 목록 응답의 has_version). 드롭다운에서 매장별 버전 API 호출 없이 진입잠금 판별용
  hasVersion: boolean;
}
